import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }

import { ref } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import UserDropdownPanel from '@/components/auth/UserDropdownPanel.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDropdown',
  setup(__props) {

const authStore = useAuthStore();
const isOpen = ref(false);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const closeDropdown = () => {
  isOpen.value = false;
};

const handleLoginClick = () => {
  // This will be handled by parent component or UserDropdownPanel
  closeDropdown();
};

const handleLogoutClick = () => {
  // This will be handled by parent component or UserDropdownPanel
  closeDropdown();
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass([
              'relative p-2 text-foreground hover:text-primary transition-colors rounded-lg hover:bg-primary/10',
              _unref(authStore).headerIconColor,
            ]),
      "aria-label": "User account",
      title: "User account",
      onClick: toggleDropdown
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'user-music'],
        class: "text-2xl"
      })
    ], 2),
    _createVNode(UserDropdownPanel, {
      "is-open": isOpen.value,
      onClose: closeDropdown,
      onLoginClicked: handleLoginClick,
      onLogoutClicked: handleLogoutClick
    }, null, 8, ["is-open"])
  ]))
}
}

})